module.exports = __webpack_public_path__ + "img/cream.1f8d3820.svg";